import React, { useEffect, useState, useRef, memo } from "react";

const MobileScreenPriceChange = ({ price, highLow, isText }) => {
  const [priceUpDown, setPriceUpDown] = useState(null);
  const prevValueRef = useRef(null);

  useEffect(() => {
    if (prevValueRef.current !== null) {
      if (price > prevValueRef.current) {
        setPriceUpDown(true);
      } else if (price < prevValueRef.current) {
        setPriceUpDown(false);
      }
    }
    prevValueRef.current = price;

    const timer = setTimeout(() => {
      setPriceUpDown(null);
    }, 1000);

    return () => clearTimeout(timer);
  }, [price]);

  return (
    <div
      className={`${
        typeof priceUpDown === "boolean"
          ? priceUpDown
            ? "bag_color-up"
            : "bag_color-down"
          : ""
      } order_card card_live_di`}
    >
      <p>{price ?? 0}</p>
      <span>
        {isText} : {highLow ?? 0}
      </span>
    </div>
  );

  // return (
  //   <div className={`${"bag_color-down"} order_card card_live_di`}>
  //     <p>{price ?? 0}</p>
  //     <span>
  //       {isText} : {highLow ?? 0}
  //     </span>
  //   </div>
  // );
};

export default memo(MobileScreenPriceChange);
